import { useContext } from 'react'
import { EnrollStepContext } from '../contexts'

export const useEnrollStepContext = () => ({
  plansToolTipKey: undefined,
  showPaperSection: true,
  enableInkPaperPlansOnEnroll: false,
  ...(useContext(EnrollStepContext) || {})
})
